var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isInnerMessage)?_c('p',{class:_vm.pClass,domProps:{"innerHTML":_vm._s(_vm.parsedMessage)}}):_c('span',{class:_vm.spanClass,domProps:{"innerHTML":_vm._s(_vm.parsedMessage)}})])}
var staticRenderFns = []

export { render, staticRenderFns }